import { Component, inject, input } from '@angular/core';
import { environment } from '@environments/environment';
import { ConfigService } from 'app/services/config.service';

@Component({
  selector: 'app-infoscreen-footer',
  imports: [],
  templateUrl: './infoscreen-footer.component.html',
  styleUrl: './infoscreen-footer.component.scss',
})
export class InfoscreenFooterComponent {
  private configService = inject(ConfigService);

  isDummyData = this.configService.isUsingMockApi();
  locationName = input<string>();
}
